import React from 'react';
import { connect } from 'react-redux';
import footerLogo from './../../../assets/images/ca_logo_white_primary.svg';

import './Footer.css';

function Footer(props) {
  const getYear = () => {
    let today = new Date()
    return today.getFullYear()
  }

  return (
    <>
      { props.isUserLoggedIn &&
      <footer className="d-flex flex-column flex-lg-row footer p-3 justify-content-lg-between">
          <span className="order-lg-1 order-2 m-top">© Cambridge University Press & Assessment {getYear()}</span>
          <div className="order-lg-2 order-1">
              <a
                id='lnkFooterMainSite'
                href='https://cambridgeinternational.org'
                target='_blank'
                rel="noopener noreferrer"
                aria-label='Go to the Cambridge Assessment International Education main website'
              >
                <img src={footerLogo} className="" alt="account-icon" />
              </a>
          </div>
      </footer>
      }
    </>
  );
}

const mapStateToProps = state => {
  return { 
    isUserLoggedIn: state.currentUser.isUserLoggedIn
   };
};

export default connect(mapStateToProps)(Footer);
